import {
  usePartnerHistoryQuery,
  usePartnerLogoQuery,
  usePartnerQuery,
} from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUsePartnerItemProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '2';

export const usePartnerItem = ({ id, handleClose }: IUsePartnerItemProps) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const partner = usePartnerQuery({
    partner_id: id,
  });

  const partnerHistory = usePartnerHistoryQuery({
    partner_id: id,
    page: historyPage,
    limit: 100,
    enabled: historyTabIndex === tabIndex,
  });

  const fetchedLogo = usePartnerLogoQuery({
    partner_id: id,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  return {
    fetchedLogo,
    partner,
    tabIndex,
    handleTriggerChangeTab,
    partnerHistory: partnerHistory.data,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    historyTabIndex,
  };
};
